/**************************************************
 * Nombre:       Tarjeta_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useNavigate} from "react-router";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";


const Tarjeta_Producto = ({item}) => {
    const navigate = useNavigate();

    const obtenerMenorValor = (variantes) => {
        let ordenado = [...variantes].sort((a, b) => {
            if (a[variantes] < b[variantes]) return -1;
            if (a[variantes] > b[variantes]) return 1;
            return 0;
        });

        return ordenado[0].valor


    }

    return (
        <Grid
            onClick={() => navigate("/Detalle/"+item.id)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{cursor: 'pointer'}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{
                      justifyContent: 'flex-start',
                      border: 1,
                      borderColor: '#00000020',
                      borderStyle: 'dashed',
                      backgroundColor: '#00000020'
                  }}>
                <img src={item?.img} width={'100%'} height={'auto'} style={{backgroundColor: '#fff'}}/>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: 2, pl: 1}}>
                {item.variantes && item.variantes[0] &&
                <Typography sx={{color: theme.palette.primary.main, fontWeight: 700}}>
                    {formatoMoneda(obtenerMenorValor(item.variantes))}
                </Typography>
                }
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end', mt: 2, pr: 1}}>
                <Typography sx={{fontWeight: 400, fontSize: 14, color: '#00000090'}}> {item?.marca}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1, lineHeight: 1.1}}>
                <Typography sx={{fontWeight: 600, fontSize: 16, lineHeight: 1.1}}>{item?.nombre}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Producto    